<template>
  <div class="link_company_follow">
    <a href="#">
      <span class="logo">
        <!--<span></span>  로고 적용시 span 삭제 -->
        <img :src="thumbnailImageWithOptions(logo, { w: 26 })" alt="" v-if="logo"><!-- 로고 적용시 이미지 노출 -->
        <SkeletonBox v-else />
      </span>
      <span class="name font_h6"><slot /></span>
    </a>
    <div class="check_text small">
      <label><input type="checkbox"><span>팔로우</span><span class="toggle">팔로잉</span></label>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useImagesThumbnail } from '~/composables/images/thumbnail'

const { logo } = defineProps<{ logo: string }>()
const { thumbnailImageWithOptions } = useImagesThumbnail()

</script>
<style scoped>
    .link_company_follow{position:relative; display: flex; justify-content: space-between; align-items: center;}
    .link_company_follow a{display: flex; align-items: center; gap:8px; width:fit-content; width:100%;}
    .link_company_follow .logo { position:relative; display:inline-block; width:36px; height:36px; background:#fff; border:1px solid var(--color-line);  border-radius:100%; box-sizing:border-box; overflow:hidden; }
    .link_company_follow .logo img{position: absolute; top: -100%; right: -100%; bottom: -100%; left: -100%; width: 100%; height: 100%; object-fit: cover; margin: auto;}
    .link_company_follow .name{color:var(--color-text-title); max-width: calc(100% - 55px); display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden; white-space: normal; word-break: break-all;}

    .link_company_follow.detail a{gap:5px;}
    .link_company_follow.detail .logo{width:24px; height:24px;}
    .link_company_follow.detail .logo span{width:24px; height:24px;}
    .link_company_follow.detail .name{font-size:var(--font-size-7); line-height:160%; color:var(--color-background-default); font-weight:normal; max-width:fit-content;}
    .link_company_follow.detail .check_text.small{margin-left:8px;}
    .link_company_follow.detail .check_text.small span{color:var(--color-background-default);}

    @media screen and (max-width: 768px) {
        .link_company_follow.detail a{width:auto;}
        .link_company_follow.detail .logo{width:28px; height:28px;}
        .link_company_follow.detail .name{font-size:var(--font-size-5); color:var(--color-text-title); font-weight:bold; max-width:calc(100% - 33px);}
        .link_company_follow.detail .check_text{display:none;}
    }
</style>
